<template>
  <div class="backStack-side-menu-wrap">
    <div class="side-menu-body-wrap">
      <a-menu
        :default-selected-keys="defaultKey"
        :default-open-keys="openKey"
        style="width: 100%"
        mode="inline"
        @click="handleClick"
        :key="key"
      >
        <template v-for="item in sideOptions">
          <a-menu-item v-if="!item.child" :key="item.key">
            <span :title="item.title">{{ item.title }}</span>
          </a-menu-item>
          <SubMenu v-else :key="item.key" :menu-info="item" />
        </template>
      </a-menu>
    </div>
  </div>
</template>

<script>
// import { cloneDeep } from 'lodash'
// import { mapGetters } from 'vuex'
import { sideOptions, nameMap, childMap } from './configs'
import SubMenu from './subMenu'
export default {
  props: {
    sideOpen: Array
  },
  data() {
    return {
      sideOptions,
      current: [],
      defaultKey: ['personal'],
      openKey: ['info', 'personal'],
      key: 1 // 刷新菜单栏的选中
    }
  },
  components: {
    SubMenu
  },
  watch: {
    $route(to) {
      const { name } = to
      this.setCurrentKeys(name)
    }
  },
  created() {
    const { name } = this.$route
    this.setCurrentKeys(name)
  },
  methods: {
    setCurrentKeys(key) {
      for (let index in nameMap) {
        if (index === key) {
          this.defaultKey = []
          this.defaultKey.push(key)
          this.openKey = nameMap[index]
          this.key++
        }
        childMap.forEach(item=>{
            item.child.forEach(ele=>{
              if(ele === key){
                this.defaultKey = []
                this.defaultKey.push(item.fName)
              }
            })
          })
      }
    },
    handleClick(e) {
      const { key, keyPath } = e
      const name = key
      const meta = keyPath[1]
      this.setCurrentKeys(key)
      this.$emit('sideMenuClick', { name, meta })
    }
  }
}
</script>
